import {
  Button,
  CloseButton,
  Dialog,
  Flex,
  Portal,
  Text,
} from '@chakra-ui/react';
import CustomDialogBackdrop from '@components/CustomDialogBackdrop';
import { useNavigate } from 'react-router';

type Props = {
  handleClose: () => void;
};

const StayInPageDialog = ({ handleClose }: Props) => {
  const navigate = useNavigate();

  const onFinish = () => {
    navigate('/painel/meus-atendimentos', { replace: true });
  };

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      onOpenChange={onFinish}
      closeOnInteractOutside={false}
    >
      <Portal>
        <CustomDialogBackdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg" m={3}>
            <Dialog.Body>
              <Text fontSize="xl" textAlign="center" fontWeight={600} my={6} lineHeight={1.2}>
                Deseja permanecer na página atual?
              </Text>
            </Dialog.Body>

            <Flex direction="column" p={3} gap={3}>
              <Button
                bg="green.700"
                variant="outline"
                onClick={onFinish}
              >
                Voltar para a lista de atendimentos
              </Button>
              <Button
                variant="outline"
                onClick={handleClose}
              >
                Permanecer
              </Button>
            </Flex>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default StayInPageDialog;
